import { render } from "./OnboardingFourthStep.vue?vue&type=template&id=768741e5&scoped=true&ts=true"
import script from "./OnboardingFourthStep.vue?vue&type=script&lang=ts"
export * from "./OnboardingFourthStep.vue?vue&type=script&lang=ts"

import "./OnboardingFourthStep.vue?vue&type=style&index=0&id=768741e5&lang=scss&scoped=true"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-768741e5"]])

export default __exports__